/*
 * Notice: This software is proprietary to Pocketbook, its affiliates, partners and/or
 * licensors. Unauthorized copying, distribution or use is strictly prohibited.
 * All rights reserved.
 */

'use strict';

angular.module('webReader')
    .directive('chaptercollection', function() {
        return {
            scope: {

            },
            restrict: 'E',
            replace: true,
            templateUrl: 'directives/chaptercollection/chaptercollection.view.html',
            controller: ["$scope", "DocumentService", "DocumentModel", "NotesModel", "NotesService", "HighlightsModel", "BookmarksModel", "BookmarksService", "$interval", "$timeout", "$window", "NetworkService", "LocalizationService", "$rootScope", function($scope, DocumentService, DocumentModel, NotesModel, NotesService, HighlightsModel, BookmarksModel, BookmarksService, $interval, $timeout, $window, NetworkService, LocalizationService, $rootScope) {
                var scope = $scope;
                var viewportOffset = 0;
                var scrollInterval;
                var viewportHeight = angular.element('content-viewport').height();
                var totalChaptersCount = 0;
                var chaptersLoaded = 0;
                var bookStartOffset;
                var scrollDisabled = true;
                var initialPositionChapterIndex;
                var chaptersRequiredNumber;
                var chapterRequired;
                var heigthAdjustmentFromBottom = false;
                var updatePositionBackgroundCheckInterval;
                var documentFormat;
                scope.currentBookmark = null;
                scope.modalHover = { chapterIsLoading: true };

                scope.page = 1;

                //@todo: move those ugly ifs into new configuration service
                if (DocumentModel.getDocumentFormat() !== 'pdf') {
                    HighlightsModel.create();
                }
                var scroll = new IScroll(angular.element('content-viewport')[0], {
                    mouseWheel: true,
                    scrollbars: false,
                    scrollX: false,
                    scrollY: true,
                    useTransition: false,
                    probeType: 3,
                    disableMouse: true,
                    disablePointer: true,
                    disableTouch: true
                });

                var updateScroll = function() {
                    NotesService.updateScrollPosition(scroll.y);
                    $timeout(function() {
                        scope.scroll.refresh();
                    }, 500);
                };

                scope.scroll = scroll;
                scroll.on('scrollEnd', function() {
                    console.warn('FIRED scrollEnd', scope);
                    debugger
                    scope.$watch('page',function(old, newVal){
                    if(newVal === 0|| old === 0){
                        scope.page = 1;
                    }
                },true);
                    var chapterLoadedCallback;
                    var newHeight = DocumentService.getLoadedDocumentHeight();
                    viewportOffset = scroll.y;
                    //  console.log(DocumentModel.getPreviousChaptersLength());
                    // debugger
                    DocumentService.updateScrollPosition(viewportOffset);
                    DocumentService.updateBookOffset(scroll.y);
                    NotesService.updateScrollPosition(scroll.y);
                    if (DocumentModel.getDocumentFormat() === 'pdf') {
                        scope.page = (DocumentService.getCurrentFocusedItem())  ;
                    } else {

                        scope.page = (Math.ceil(scope.pagesTotal *
                         (DocumentModel.getPreviousChaptersLength() +
                          (DocumentModel.getLoadedContentLength() *
                         (-viewportOffset / angular.element('content-wrapper').height()))) /
                          DocumentModel.getTotalContentLength()));
                    }
                    //TODO
                    DocumentService.updateCurrentPageNumber(scope.page);
                    DocumentService.updateCurrentBookOffset(scroll.y);
                    if ((scroll.y + DocumentService.getLoadedDocumentHeight()) < 2 * viewportHeight &&
                        initialPositionChapterIndex + chaptersLoaded < totalChaptersCount &&
                        !DocumentModel.getChapterStatus(initialPositionChapterIndex + chaptersLoaded)) {
                        heigthAdjustmentFromBottom = false;
                        scope.modalHover.chapterIsLoading = true;

                        chapterLoadedCallback = DocumentModel.subscribe.onChapterLoaded(initialPositionChapterIndex + chaptersLoaded, function() {
                            DocumentModel.unsubscribe.onChapterLoaded(initialPositionChapterIndex + chaptersLoaded, chapterLoadedCallback);
                            chaptersLoaded += 1;
                            scope.chapters = DocumentModel.getLoadedChapters();
                        });
                        DocumentModel.loadChapter(initialPositionChapterIndex + chaptersLoaded);

                    } else if (scroll.y > -2 * viewportHeight &&
                        chaptersLoaded < totalChaptersCount && !DocumentModel.getChapterStatus(0)) {
                        scope.modalHover.chapterIsLoading = true;

                        heigthAdjustmentFromBottom = true;
                        initialPositionChapterIndex -= 1;
                        chapterLoadedCallback = DocumentModel.subscribe.onChapterLoaded(initialPositionChapterIndex, function() {
                            DocumentModel.unsubscribe.onChapterLoaded(initialPositionChapterIndex, chapterLoadedCallback);
                            chaptersLoaded += 1;
                            scope.chapters = DocumentModel.getLoadedChapters();
                        });
                        DocumentModel.loadChapter(initialPositionChapterIndex);

                    } else {
                        scope.modalHover.chapterIsLoading = false;

                    }
                    BookmarksService.updateScrollPosition(scroll.y);

                    //start background position-check interval if not startedd before
                    if (!updatePositionBackgroundCheckInterval) {
                        updatePositionBackgroundCheckInterval = $interval((function() {
                            var previousPosition = DocumentService.getCurrentChapterOffsetObject();

                            return function() {
                                var currentPosition = DocumentService.getCurrentChapterOffsetObject();

                                if (currentPosition.offsetChars !== previousPosition.offsetChars ||
                                    currentPosition.pOffset !== previousPosition.pOffset) {
                                    NetworkService.updateBookOffset(currentPosition);
                                    previousPosition = currentPosition;
                                }
                            };
                        })(), 120000);
                    }

                    scope.currentChapterTitle = DocumentService.getCurrentChapterOffsetObject().chapterTitle;
                    scope.scroll.refresh();

                });

                scroll.on('scroll', function() {
                    NotesService.updateScrollPosition(scroll.y);
                    viewportOffset = scroll.y;

                    if (DocumentModel.getDocumentFormat() === 'pdf') {
                        scope.page = DocumentService.getCurrentFocusedItem();
                    } else {
                        scope.page = Math.ceil(scope.pagesTotal * (DocumentModel.getPreviousChaptersLength() + (DocumentModel.getLoadedContentLength() * (-viewportOffset / angular.element('content-wrapper').height()))) / DocumentModel.getTotalContentLength());
                    }
                    //TODO
                    DocumentService.updateCurrentPageNumber(scope.page);
                    scope.$watch('page',function(old, newVal){
                    if(newVal === 0|| old === 0){
                        scope.page = 1;
                    }
                },true);
                    NotesService.updateScrollPosition(scroll.y);
                    !scope.$root.$$phase && scope.$digest();
                });

                function updateViewportOffset(delta) {
                    var viewportElement = angular.element('content-wrapper');

                    NotesService.updateScrollPosition(scroll.y);

                    DocumentService.updateCurrentBookOffset(scroll.y)

                    viewportOffset += delta;
                    viewportOffset = -Math.min(-viewportOffset, angular.element('content-wrapper').height() - angular.element('content-viewport').height());
                    scroll.scrollTo(0, viewportOffset + 250, 10);
                    NotesService.updateScrollPosition(scroll.y);
                    DocumentService.updateCurrentBookOffset(scroll.y)
                    DocumentService.updateBookOffset(scroll.y)
                };

                $scope.startScroll = function(delta) {
                    NotesService.updateScrollPosition(scroll.y);
                    if (!scrollInterval && !scrollDisabled) {
                        scrollInterval = $interval(function() {
                            updateViewportOffset(50 * delta);
                        }, 10);
                    }
                };

                $scope.stopScroll = function() {
                    $interval.cancel(scrollInterval);
                    scrollInterval = null;
                    NotesService.updateScrollPosition(scroll.y);
                };

                $scope.shiftPage = function(delta) {
                    NotesService.updateScrollPosition(scroll.y);
                    updateViewportOffset(viewportHeight * delta);
                    NotesService.updateScrollPosition(scroll.y);
                };


                DocumentService.create();

                DocumentService.subscribe.onDocHeightChange(function(params) {
                    console.warn('onDocHeightChange params: ',params);
                    var newHeight = DocumentService.getLoadedDocumentHeight();
                    var totalDocHeight = DocumentService.getTotalDocumentHeight();
                    var chapterLoadedCallback;
                    scroll.refresh();
                    DocumentModel.updateChaptersOffsets();
                    if (DocumentModel.getDocumentFormat() === 'pdf') {
                        console.log('PDF: DocumentModel', DocumentModel);
                        scope.pagesTotal = DocumentModel.getChaptersCount();
                    } else {
                        // console.log('NOT PDF: totalDocHeight', totalDocHeight);
                        // console.log('NOT PDF: angular.element(\'content-viewport\').height()', angular.element('content-viewport').height());
                        scope.pagesTotal = Math.ceil(totalDocHeight / angular.element('content-viewport').height());
                    }
                      // $rootScope.pagesTotal = scope.pagesTotal;
                    //   console.log(scope.pagesTotal,  $rootScope.pagesTotal)
                    //TODO
                    DocumentService.updatePagesCount(scope.pagesTotal);

                    _.isNumber(chaptersRequiredNumber) && chaptersRequiredNumber--;

                    if ((_.isNull(chaptersRequiredNumber) || _.isUndefined(chaptersRequiredNumber)) && initialPositionChapterIndex + chaptersLoaded < totalChaptersCount &&
                        (_.isUndefined(bookStartOffset) || (bookStartOffset + scroll.y + newHeight < 2 * viewportHeight)) &&
                        DocumentModel.getChapterStatus(initialPositionChapterIndex + chaptersLoaded) !== 'LOADED') {
                        if (!DocumentModel.getChapterStatus(initialPositionChapterIndex + chaptersLoaded)) {
                            chapterLoadedCallback = DocumentModel.subscribe.onChapterLoaded(initialPositionChapterIndex + chaptersLoaded, function() {
                                DocumentModel.unsubscribe.onChapterLoaded(initialPositionChapterIndex + chaptersLoaded, chapterLoadedCallback);
                                chaptersLoaded += 1;
                                scope.chapters = DocumentModel.getLoadedChapters();
                            });
                            DocumentModel.loadChapter(initialPositionChapterIndex + chaptersLoaded);
                        }
                    } else {
                        scrollDisabled = false;
                        scroll.options.disableMouse = false;
                        scroll.options.disablePointer = false;
                        scroll.options.disableTouch = false;

                        if (!_.isNumber(chaptersRequiredNumber) && bookStartOffset) {
                            console.log('bookStartOffset',bookStartOffset);
                            scroll.scrollTo(0, bookStartOffset, 100);
                            bookStartOffset = null;
                        } else if (chaptersRequiredNumber === 0) {
                            if (!((DocumentModel.getChapterOffset(chapterRequired) + DocumentService.getLoadedDocumentHeight()) < 2 * viewportHeight &&
                                    initialPositionChapterIndex + chaptersLoaded < totalChaptersCount &&
                                    !DocumentModel.getChapterStatus(initialPositionChapterIndex + chaptersLoaded))) {
                                DocumentModel.updateChaptersOffsets();
                                bookStartOffset = null;
                                chaptersRequiredNumber = null;
                            }!_.isNull(chaptersRequiredNumber) && chaptersRequiredNumber++;
                            scroll.scrollTo(0, DocumentModel.getChapterOffset(chapterRequired), 100);
                        } else if (!_.isNumber(chaptersRequiredNumber) && heigthAdjustmentFromBottom) {
                            scroll.scrollBy(0, -params.deltaHeight, 100);
                            DocumentService.updateBookOffset(scroll.y);
                        } else if (!_.isNumber(chaptersRequiredNumber)) {
                            scope.modalHover.chapterIsLoading = false;
                        }
                    }
                    updateScroll();
                });

                NotesService.create(angular.element('content-block'));

                DocumentModel.subscribe.onModelUpdate(function() {
                    var chapterLoadedCallback;
                    var initialPosition;
                    var chapterRenderedCallback;
                    documentFormat = DocumentModel.getDocumentFormat();

                    scope.modalHover.chapterIsLoading = true;
                    //try to get position
                    // debugger
                    initialPosition = DocumentService.getInitialBookPosition();
                    //if position content is valid, get index of chapter from position
                    if (!!initialPosition) {
                        initialPositionChapterIndex = DocumentModel.getChapterIdByUrl(initialPosition.url);
                        //if initialChapterIndex > 0, recrement it in order to start loading from previous chapter
                    } else {
                        initialPositionChapterIndex = 0;
                    }

                    totalChaptersCount = DocumentModel.getChaptersCount();

                    //if index > 0 then load previous chapter
                    // TODO: why we need to load PREVIOUS? position of book will be wrong?
                    // TODO: chapter scrolls here
                    if (!!initialPositionChapterIndex) {
                        // debugger
                        initialPositionChapterIndex--;
                        chapterLoadedCallback = DocumentModel.subscribe.onChapterLoaded(initialPositionChapterIndex, function() {
                            DocumentModel.unsubscribe.onChapterLoaded(initialPositionChapterIndex, chapterLoadedCallback);
                            chaptersLoaded += 1;
                            scope.chapters = DocumentModel.getLoadedChapters();

                            chapterLoadedCallback = DocumentModel.subscribe
                                .onChapterLoaded(initialPositionChapterIndex + chaptersLoaded, function () {
                                    DocumentModel.unsubscribe
                                        .onChapterLoaded(initialPositionChapterIndex + chaptersLoaded, chapterLoadedCallback);
                                    chaptersLoaded += 1;
                                    scope.chapters = DocumentModel.getLoadedChapters();
                                });
                            // debugger
                            chapterRenderedCallback = DocumentService.subscribe
                                .onChapterRendered(initialPositionChapterIndex + chaptersLoaded, function () {
                                    DocumentService.unsubscribe
                                        .onChapterRendered(initialPositionChapterIndex, chapterRenderedCallback);
                                    if (_.isUndefined(bookStartOffset)) {
                                        bookStartOffset = DocumentService.getInitialChapterOffset(); // || DocumentService.getBookOffset();;
                                    }
                                });
                            DocumentModel.loadChapter(initialPositionChapterIndex + chaptersLoaded);
                        });

                        DocumentModel.loadChapter(initialPositionChapterIndex);
                    } else { //if initial chapter index is 0
                        chapterLoadedCallback = DocumentModel.subscribe.onChapterLoaded(initialPositionChapterIndex + chaptersLoaded, function() {
                            DocumentModel.unsubscribe.onChapterLoaded(chaptersLoaded, chapterLoadedCallback);
                            chaptersLoaded += 1;
                            scope.chapters = DocumentModel.getLoadedChapters()
                        });

                        chapterRenderedCallback = DocumentService.subscribe.onChapterRendered(initialPositionChapterIndex + chaptersLoaded, function() {
                            DocumentService.unsubscribe.onChapterRendered(initialPositionChapterIndex, chapterRenderedCallback);
                            if (_.isUndefined(bookStartOffset)) {
                                bookStartOffset = DocumentService.getInitialChapterOffset(); // || DocumentService.getBookOffset();;
                            }
                        });

                        DocumentModel.loadChapter(initialPositionChapterIndex);
                    }

                    $timeout(function() {
                        var timeoutHandler;
                        var bookmarkTimeoutHandler;
                        var fadeElements;
                        var bookmarkFadeElement;

                        angular.element('content-block a.ico').addClass('a-fade-out');

                        angular.element('reader-chaptercollection').bind('mousemove', (function() {
                            var revArrowElement = angular.element('content-block a.navigate-prev');
                            var fwdArrowElement = angular.element('content-block a.navigate-next');
                            var revArrowXLimit = revArrowElement.position().left + revArrowElement.parent().position().left + revArrowElement.width() + 35;
                            var fwdArrowXLimit = fwdArrowElement.position().left + fwdArrowElement.parent().position().left;
                            var revArrowHidden;
                            var fwdArrowHidden;

                            return function(e) {
                                //@toDo: add xy mmove range for add-bookmark btn
                                var position = { x: e.screenX, y: e.screenY };
                                var timeoutCollection = [{
                                        hiddenObject: angular.element('content-block a.add-bookmark'),
                                        timeoutObject: null,
                                        xRange: 200,
                                        yRange: 200
                                    },
                                    //{
                                    //    hiddenObject: angular.element('content-block a.navigate-prev'),
                                    //    timeoutObject: null,
                                    //    xRange: 50,
                                    //    yRange: 100
                                    //},
                                    //{
                                    //    hiddenObject: angular.element('content-block a.navigate-next'),
                                    //    timeoutObject: null,
                                    //    xRange: 50,
                                    //    yRange: 100
                                    //}
                                ];


                                //arrows check
                                if (!!revArrowHidden !== (position.x > revArrowXLimit)) {
                                    revArrowHidden = !revArrowHidden;
                                    revArrowElement.toggleClass('a-fade-out', revArrowHidden);
                                }

                                if (!!fwdArrowHidden !== (position.x < fwdArrowXLimit)) {
                                    fwdArrowHidden = !fwdArrowHidden;
                                    fwdArrowElement.toggleClass('a-fade-out', fwdArrowHidden);
                                }

                                _.each(timeoutCollection, function(el, i) {
                                    var _el = el;

                                    if (Math.abs(el.hiddenObject.position().left + el.hiddenObject.parent().position().left - position.x) < el.xRange &&
                                        Math.abs(el.hiddenObject.position().top - position.y) < el.yRange) {

                                        if (!!el.timeoutObject) {
                                            $timeout.cancel(el.timeoutObject);
                                            el.timeoutObject = null;
                                        } else {
                                            el.hiddenObject.removeClass('a-fade-out');
                                        }

                                        el.timeoutObject = $timeout(function() {
                                            _el.hiddenObject.addClass('a-fade-out');
                                            _el.timeoutObject = null;
                                        }, 3000);
                                    }
                                });
                            }
                        })());
                    }, 5000);
                    DocumentService.updateStatus.setScrollCreated();
                });

                DocumentModel.subscribe.onChaptersStatusChange(function(params) {
                    //scope.modalHover.chapterIsLoading = (params[0].newStatus === 'LOADING');
                });

                $scope.navigatePrev = function() {
                    startScroll(1);
                };
                $scope.navigateNext = function() {
                    updateViewportOffset(-25);
                };

                DocumentService.subscribe.onDocScrollRequested(function(params) {
                    var cfiPositionString = params[0].cfiPositionString;
                    var cfiPositionObject = !!cfiPositionString && DocumentService.parseCfiPosition(cfiPositionString);
                    var chapterId = DocumentModel.getChapterIdByUrl(params[0].chapterUrl || cfiPositionObject.url);
                    var cfiOffset = 0;
                    var nextChapterLoadedCallback, finalChapterLoadedContent;
                    var loadedChapters;
                    var loopDelta, loopStart, loadingCallbacks = {};
                    var cfiChapterOffsetObject;


                    if (DocumentModel.checkIf.isChapterLoaded(chapterId)) {
                        if (!!cfiPositionString) {
                            cfiChapterOffsetObject = DocumentService.getChapterOffsetObject(cfiPositionObject.offsetChar, chapterId);
                            if (!!cfiChapterOffsetObject) {
                                cfiOffset = -angular.element(cfiChapterOffsetObject.element).position().top + parseInt(cfiPositionObject.pOffset);
                            }
                        } else {
                            cfiOffset = DocumentModel.getChapterOffset(chapterId);
                        }

                        updateViewportOffset(cfiOffset - viewportOffset);
                    } else {
                        scope.modalHover.chapterIsLoading = true;
                        loadedChapters = DocumentModel.getLoadedChapters();
                        loopDelta = (chapterId < loadedChapters[0].index) ? -1 : 1;
                        loopStart = (loopDelta > 0) ? loadedChapters[loadedChapters.length - 1].index : loadedChapters[0].index;
                        heigthAdjustmentFromBottom = loopDelta < 0;
                        chaptersRequiredNumber = Math.abs(loopStart - chapterId);
                        chapterRequired = chapterId;

                        for (loopStart += loopDelta; loopStart !== chapterId; loopStart += loopDelta) {
                            initialPositionChapterIndex -= (loopDelta > 0) ? 0 : 1;
                            loadingCallbacks[loopStart] = DocumentModel.subscribe.onChapterLoaded(loopStart, (function() {
                                var currentChapterId = loopStart;

                                return function() {
                                    DocumentModel.unsubscribe.onChapterLoaded(currentChapterId, loadingCallbacks[currentChapterId]);
                                    chaptersLoaded += 1;
                                    scope.chapters = DocumentModel.getLoadedChapters();
                                }
                            })());
                            DocumentModel.loadChapter(loopStart);
                        }

                        //loading last required chapter
                        loadingCallbacks[chapterId] = DocumentModel.subscribe.onChapterLoaded(chapterId, function() {
                            var chapterRenderedCallbackId;

                            DocumentModel.unsubscribe.onChapterLoaded(chapterId, loadingCallbacks[chapterId]);
                            initialPositionChapterIndex -= (loopDelta > 0) ? 0 : 1;
                            chaptersLoaded += 1;
                            scope.chapters = DocumentModel.getLoadedChapters();

                            chapterRenderedCallbackId = DocumentService.subscribe.onChapterRendered(chapterId, function() {
                                DocumentService.unsubscribe.onChapterRendered(chapterId, chapterRenderedCallbackId);
                                if (!!cfiPositionString) {
                                    cfiChapterOffsetObject = DocumentService.getChapterOffsetObject(cfiPositionObject.offsetChar, chapterId);
                                    if (!!cfiChapterOffsetObject) {
                                        cfiOffset = -angular.element(cfiChapterOffsetObject.element).position().top + parseInt(cfiPositionObject.pOffset);
                                    }
                                } else {
                                    cfiOffset = DocumentModel.getChapterOffset(chapterId);
                                }

                                bookStartOffset = cfiOffset;
                            });
                        });

                        DocumentModel.loadChapter(loopStart);
                    }

                    $timeout(function() {
                        NetworkService.updateBookOffset(DocumentService.getCurrentChapterOffsetObject());
                    }, 20000);
                });

                //$window.onbeforeunload = function(){
                //    NetworkService.updateBookOffset(DocumentService.getCurrentChapterOffsetObject(), true);
                //    return false;
                //};


                scope.notesPopover = {
                    opened: false,
                    selection: {},
                    lastEventObject: null,
                    clickHandler: function($event) {
                        if (documentFormat === 'pdf') {
                            return;
                        }

                        var self = this;
                        var event = $event;

                        if ($event) {
                            this.lastEventObject = $event;
                        } else {
                            event = this.lastEventObject;
                        }


                        if (!scope.popoverOpened && !scope.contextMenu.isOpen) {
                            if ($event.button === 0) {
                                var eventY = $event.clientY;
                                var selectionObject = window.getSelection();

                                if (!!window.getSelection().toString()) {
                                    self.selection = {
                                        anchorNode: selectionObject.anchorNode,
                                        anchorOffset: selectionObject.anchorOffset,
                                        extentNode: selectionObject.extentNode || selectionObject.focusNode,
                                        extentOffset: selectionObject.extentOffset || selectionObject.focusOffset,
                                        selectionText: selectionObject.toString(),
                                        className: ''
                                    };

                                    $timeout(function() {
                                        //open notice/bookmark popover
                                        self.openMainPopup(event);
                                    }, 100);
                                } else {
                                    //open context menu
                                    showContext($event);
                                }
                            }
                        } else {
                            scope.popoverOpened = false;
                            if (this.opened) {
                                this.opened = false;
                            }

                            self.mainContextOpened = false;
                            scope.contextMenu.isOpen = false;
                        }
                    },
                    tpl: 'directives/bookmark-popup/bookmark-popup.view.html',
                    mainContextTpl: 'directives/bookmark-popup/main-popup.view.html',
                    translatePopupTpl: 'directives/bookmark-popup/translate.popup.view.html',
                    open: function($event) {
                        var eventY = $event.clientY;
                         // console.log('open',$event.clientY )
                        scope.popoverPlacement = 'left';
                        scope.popoverTemplate = this.tpl;
                        scope.popoverOpened = true;
                        scope.popoverClass = 'notes-popover';
                        scope.modalHover.chapterIsLoading = true;
                        scope.modalHover.hideSpinner = true;
                        this.opened = true;

                        $timeout(function() {
                            angular.element('body > .popover')[0].customLeft = angular.element('content-block').position().left - 230;
                            angular.element('body > .popover')[0].customTop = eventY - 80;
                            angular.element('body > .popover').removeClass('top main-notes-popover').addClass('left notes-popover');
                        });
                    },
                    openMainPopup: function($event) {

                        var eventY = $event.clientY;
                        var eventX = $event.clientX;

                        scope.popoverPlacement = 'top';
                        scope.popoverTemplate = this.mainContextTpl;
                        scope.popoverClass = 'main-notes-popover';
                        scope.mainContextOpened = true;
                        scope.popoverOpened = true;

                        $timeout(function() {
                            var minTop = 20;

                            angular.element('body > .popover')[0].customLeft = eventX - angular.element('body > .popover').width() / 2;
                            angular.element('body > .popover')[0].customTop = Math.max(eventY - 150, minTop);
                            angular.element('body > .popover').removeClass('left notes-popover').addClass('top main-notes-popover');
                        });
                    },
                    openTranslatePopup: function($event, translation) {
                        var eventY = $event.clientY;
                        var eventX = $event.clientX;

                        scope.popoverPlacement = 'top';
                        scope.popoverTemplate = this.translatePopupTpl;
                        scope.popoverClass = 'translate-popover';
                        scope.popoverOpened = true;
                        this.opened = true;
                        this.translation = translation;
                        this.translation.targetLanguage = LocalizationService.getTargetLanguage();

                        $timeout(function() {
                            var minTop = 20;

                            angular.element('body > .popover')[0].customLeft = eventX - angular.element('body > .popover').width() / 2;
                            angular.element('body > .popover')[0].customTop = Math.max(eventY - angular.element('body > .popover').height(), minTop);
                            angular.element('body > .popover').removeClass('left notes-popover').addClass('top translate-popover');
                        });
                    },
                    addNoteClick: function() {
                        this.close();
                        this.open(this.lastEventObject);
                    },
                    translateClick: function() {
                        var popover = this;

                        this.close();
                        DocumentModel.getTranslation(this.selection.selectionText).then(
                            function(data) {
                                popover.openTranslatePopup(popover.lastEventObject, { output: data.data.translations[0] });
                            }
                        );
                    },
                    addHighlightClick: function(param) {
                        // console.log(param);
                        if (!!this.selection.selectionText) {
                            this.selection.className = param;
                            HighlightsModel.addHighlight(this.selection, this.noticeText);
                            // NotesModel.addNote(this.selection, this.noticeText, param);
                            this.noticeText = '';
                        }
                        this.close();
                    },
                    close: function() {
                        this.opened = false;
                        scope.popoverOpened = false;
                        scope.modalHover.chapterIsLoading = false;
                        scope.modalHover.hideSpinner = false;
                    },
                    closeMainPopup: function() {
                        this.mainContextOpened = false;
                        scope.popoverOpened = false;
                    },
                    cancel: function() {
                        this.close();
                    },
                    cancelMainPopup: function() {
                        this.closeMainPopup();
                    },
                    apply: function() {
                        if (!!this.noticeText) {
                            NotesModel.addNote(this.selection, this.noticeText);
                            this.noticeText = '';
                            this.close();
                        }
                        scope.modalHover.chapterIsLoading = false;
                    },
                    taChange: function(e) {
                        // e.target.style.height = '44px';
                        // e.target.style.height = (e.target.scrollHeight) + "px";
                    }
                };

                scope.contextMenu = {
                    isOpen: false,
                    left: 0,
                    top: 0
                };

                scope.addBookmark = function(e, page) {
                    if (angular.element('content-block .add-bookmark').hasClass('add-bookmark-plus')) {
                        BookmarksModel.addBookmark(page);
                    } else {
                        BookmarksModel.removeBookmark(scope.currentBookmark.uuid);
                        scope.currentBookmark = null;
                        angular.element('content-block .add-bookmark')
                            .addClass('add-bookmark-plus');
                    }
                };

                var showContext = function(e) {
                    var maxLeft = $(window).width() - 331 - 20;
                    var maxTop = $(window).height() - 255 - 20;

                    scope.contextMenu.left = Math.min(e.clientX, maxLeft);
                    scope.contextMenu.top = Math.min(e.clientY, maxTop);
                    scope.contextMenu.isOpen = true;
                    // !scope.$root.$$phase && scope.$digest();
                    e.stopPropagation();
                    e.preventDefault();
                };

                DocumentService.subscribe.onSpinnerStateChangeRequested(function(params) {

                    scope.modalHover.chapterIsLoading = params.newValue;
                    scope.modalHover.hideSpinner = params.hideSpinner;
                });

                var bookmarkOffsetChangeHandler = function(params) {
                    var bookmarksCollection = BookmarksService.getBookmarks();
                    scope.currentBookmark = null;
                    // console.log(params, 'params chaptr');
                    for (var i = 0; i < bookmarksCollection.length; i++) {
                        if (angular.element(bookmarksCollection[i].bookmarkReferencedObject.element).position()) {
                            var bookmarkElementTop = angular.element(bookmarksCollection[i].bookmarkReferencedObject.element).position().top + scroll.y;
                            // add crutch
                                bookmarksCollection[i].offsetTop = angular.element(bookmarksCollection[i].bookmarkReferencedObject.element).position().top;
                                // $rootScope.bookmarks.push({i: i, offsetTop: bookmarksCollection[i].offsetTop})
                                // console.log(angular.element(bookmarksCollection[i].bookmarkReferencedObject.element).position().top)
                            if (viewportHeight + bookmarkElementTop > 0 && bookmarkElementTop < viewportHeight) {
                                scope.currentBookmark = bookmarksCollection[i];
                            }
                        }

                    }
                    if (!!scope.currentBookmark) {
                        angular.element('content-block .add-bookmark')
                            .removeClass('add-bookmark-plus');
                    } else {
                        angular.element('content-block .add-bookmark')
                            .addClass('add-bookmark-plus');
                    }
                     BookmarksService.subscribe.onRenderedBookmarksUpdate(bookmarkOffsetChangeHandler);
                    // !scope.$root.$$phase && scope.$digest();
                };

                BookmarksService.subscribe.onBookmarksWrapperOffsetChange(bookmarkOffsetChangeHandler);
                BookmarksService.subscribe.onRenderedBookmarksUpdate(bookmarkOffsetChangeHandler);
                var noop = function(e) {
                    if (!!e) {
                        e.stopPropagation();
                        e.preventDefault();
                    }
                };

                BookmarksService.subscribe.onRenderedBookmarksUpdate(bookmarkOffsetChangeHandler);
                window.addEventListener('contextmenu', noop);
                angular.element(window).bind('resize', function(e) {
                    BookmarksService.subscribe.onRenderedBookmarksUpdate(bookmarkOffsetChangeHandler);
                    NotesService.updateScrollPosition(scroll.y);
                    DocumentService.recalculateDocumentHeight();
                    scroll.refresh();
                }).bind('keypress', (function() {
                    //var previousTheme;
                    //var bodyElement = angular.element('body');
                    //var swTimeout;
                    //
                    //return function(e){
                    //    if(e.shiftKey && e.charCode === 94){
                    //        if(!bodyElement.hasClass('starwars')){
                    //            previousTheme = scope.getCurrentTheme();
                    //            scope.colorThemeUpdate('black starwars');
                    //            swTimeout = $interval(function(){
                    //                scope.shiftPage(-0.001);
                    //            }, 10);
                    //        } else {
                    //            scope.colorThemeUpdate(previousTheme);
                    //            previousTheme = null;
                    //            $interval.cancel(swTimeout);
                    //        }
                    //    }
                    //};
                })()).bind('keydown', function(e) {
                    if (e.keyCode === 37) {
                        scope.shiftPage(0.5);
                        NotesService.updateScrollPosition(scroll.y);
                        e.stopPropagation();
                        e.preventDefault();
                    } else if (e.keyCode === 39) {
                        NotesService.updateScrollPosition(scroll.y);
                        scope.shiftPage(-0.5);
                        e.stopPropagation();
                        e.preventDefault();
                    }
                });
            }]
        };
    });